import { render } from "./homePage.vue?vue&type=template&id=4f3a3edf&scoped=true"
import script from "./homePage.vue?vue&type=script&lang=js"
export * from "./homePage.vue?vue&type=script&lang=js"

import "./homePage.vue?vue&type=style&index=0&id=4f3a3edf&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f3a3edf"]])

export default __exports__